import { type PropsWithChildren } from "react";

import {
  Alert,
  Link as DSLink,
  Heading,
  SpotIcon,
} from "@icg360/design-system";

import { FooterBanner } from "components/shared/footer-banner";
import UnauthLayout from "components/shared/unauth-layout/index";
import { useFlags } from "utils";

const PaperlessEnrollmentStatus = ({ children }: PropsWithChildren) => (
  <>
    <UnauthLayout size="lg">
      <SpotIcon name="Paperless" size="md" />
      <Heading size="lg">SageSure Paperless Enrollment</Heading>
      {children}
    </UnauthLayout>
    <FooterBanner
      bannerText="Easily manage your policy with an online SageSure account."
      bannerButtonText="Register for an Account"
      bannerLink="/auth/signup"
    />
  </>
);

const EnrollmentSuccessfulStatus = () => (
  <PaperlessEnrollmentStatus>
    <Alert
      appearance="success"
      title=""
      description="Your enrollment was successful."
    />
    <div>
      Thank you for opting to go paperless! All future policy documents will be
      sent to you via email.
    </div>
  </PaperlessEnrollmentStatus>
);

const AlreadyEnrolledStatus = () => (
  <PaperlessEnrollmentStatus>
    <Alert
      appearance="info"
      title=""
      description="Our records show that you're already enrolled in paperless."
    />
    <div>
      <DSLink href="/">Log in</DSLink> to your SageSure account to access your
      policy online.
    </div>
  </PaperlessEnrollmentStatus>
);

const EnrollmentErrorStatus = () => {
  const { supportPhoneNumber } = useFlags();
  return (
    <PaperlessEnrollmentStatus>
      <Alert
        appearance="danger"
        title=""
        description="We're unable to complete your enrollment at the moment."
      />
      <div>
        Please click the link in your email to try again. If you are still
        unable to enroll, contact our Customer Care team at{" "}
        <DSLink href="mailto:customercare@sagesure.com">
          customercare@sagesure.com
        </DSLink>{" "}
        or{" "}
        <DSLink href={`tel:${String(supportPhoneNumber)}`}>
          {supportPhoneNumber}
        </DSLink>
        .
      </div>
    </PaperlessEnrollmentStatus>
  );
};

export {
  EnrollmentSuccessfulStatus,
  EnrollmentErrorStatus,
  AlreadyEnrolledStatus,
};
